module.exports = __webpack_public_path__ + "img/AI_3.06d2998c.png";